import React from "react";
import { Route, Redirect } from "react-router-dom";

import Position from "./position/index";
import Detail from "./detail/index";
import Consumption from "./consumption/index";

import Brand from "./index";

const Router = ({ match }) => {
  return (
    <React.Fragment>
      <Route exact path={`${match.path}`} component={Brand}></Route>
      <Route
        exact
        path={`${match.path}/position/:id`}
        component={Position}
      ></Route>
      <Route exact path={`${match.path}/detail/:id`} component={Detail}></Route>
      <Route
        exact
        path={`${match.path}/consumption/:id`}
        component={Consumption}
      ></Route>
    </React.Fragment>
  );
};
export default Router;
